module.exports = __webpack_public_path__ + "static/img/14.b9f0ca6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/zh/14.png
// module id = Oof9
// module chunks = 0